import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { EFItineraryContent, EFProduct, EFSupplier } from '../../../models/experience.model';
import { LocalizationService } from '../../../services/localization.service';
import { MapStylesService } from '../../../services/map-styles.service';
import { EFDataService } from '../../../services/ef-data.service';
import { PGUtilities } from '../../../utilities/pg-utilities';
import { GoogleMapsService } from '../../../services/google-maps.service';

@Component({
    selector: 'app-ef-itinerary-stop-card',
    templateUrl: './ef-itinerary-stop-card.component.html',
    styleUrls: ['./ef-itinerary-stop-card.component.scss'],
    standalone: false
})
export class EfItineraryStopCardComponent implements OnInit {

    constructor(private localizationService:LocalizationService, private mapStylesService:MapStylesService, private dataService:EFDataService, private googleMapsService:GoogleMapsService) { }

    @Input() stopData:EFItineraryContent;
    @Input() disabled:boolean;
    @Input() singleDay:boolean;
    @Input() full:boolean;
    @Input() appMode:'web'|'kiosk'|'hybrid'|'iframe'|'iframekiosk';

    @Output() showStop = new EventEmitter<void>();

    isLoadingAdditionalPoIs = false;
    additionalPoIs:Array<EFProduct> = null;

    ngOnInit(): void {
        if(this.full) {
            let _additionalPois = PGUtilities.tryParseJSON(this.stopData.additional_pois)
            if(_additionalPois != null && 'length' in _additionalPois && _additionalPois.length > 0) {
                this.isLoadingAdditionalPoIs = true;
                this.additionalPoIs = [];

                let _reqCount = 0;

                for(let i = 0; i < _additionalPois.length; i++) {
                    _reqCount++;

                    this.dataService.getResourceProduct('Poi', _additionalPois[i]).subscribe((data) => {
                        this.additionalPoIs[i] = data

                        _reqCount--;
                        if(_reqCount == 0) {
                            this.isLoadingAdditionalPoIs = false;
                            this.initMap()
                        }
                    })
                }
            }

            this.loadSource()
        }
    }

    getTranslatedProperty(prop:string) {
        return this.localizationService.getTranslatedValue(this.stopData[prop])
    }

    private _getStopProductType() {
        let _resource = this.stopData.resource;

        if(_resource == 'External') _resource = 'Poi';
        return this.dataService.getProductTypeFromResource(_resource)
    }

    getTypeColor() {
        let _type = this._getStopProductType();

        return this.mapStylesService.markerStyles[_type]?.icon.fillColor;
    }
    
    getTypeIcon() {
        let _type = this._getStopProductType();

        return this.mapStylesService.markerStyles[_type]?.label.text;
    }

    getTypeText() {
        let _type = this._getStopProductType();

        return this.localizationService.translate('experience-finder.general.product-type-' + _type)
    }

    getCoverImage() {
        if(this.stopData.image != null && this.stopData.image != '') return this.stopData.image;
    }

    onCardClick() {
        this.showStop.emit()
    }

    @ViewChild('gmapsElement') gmapsElement: ElementRef;

    map:google.maps.Map = null;
    mapMarkers:Array<google.maps.Marker> = null;

    initMap() {
        if(this.gmapsElement != null) {
            this.googleMapsService.loadMaps().then(() => {
                this.map = new google.maps.Map(this.gmapsElement.nativeElement, {
                    center: new google.maps.LatLng(0, 0),
                    zoom: 1,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    disableDefaultUI: true,
                    styles: this.mapStylesService.mapStyles.light,
                    gestureHandling: 'cooperative'
                })

                this.mapMarkers = []
        
                for(let i = 0; i < this.additionalPoIs.length; i++) {
                    let _item = this.additionalPoIs[i];
    
                    if(_item.geolocation != null) {
                        let _mapMarker = new google.maps.Marker({ 
                            position: new google.maps.LatLng(_item.geolocation.coordinates[0], _item.geolocation.coordinates[1]),
                            zIndex: 10,
                            label: (i + 1).toString(),
                            icon: this.mapStylesService.markerStyles.general.icon,
                        })
    
                        _mapMarker.setMap(this.map)
    
                        this.mapMarkers.push(_mapMarker)
                    }
                }
        
                this.centerMap();
            })
        }
    }

    centerMap() {
        if(this.mapMarkers != null) {
            let _bounds = new google.maps.LatLngBounds();
                 
            for(let _item of this.mapMarkers) {
                _bounds.extend(_item.getPosition());           
            }

            this.map.fitBounds(_bounds);
        }
    }

    showSource = false;
    isLoadingSource = false;

    productData:EFProduct = null;
    supplierData:EFSupplier = null;

    loadSource() {
        this.productData = null;
        this.supplierData = null;
        
        if(this.stopData.element != null) {
            this.isLoadingSource = true;

            this.dataService.getResourceProduct(this.stopData.resource, this.stopData.element).subscribe((data) => {
                this.productData = data;
    
                if(data.supplier != null) {
                    this.dataService.getResourceSupplier(data.supplier.split('_')[0], data.supplier.split('_')[1]).subscribe((data) => {
                        this.supplierData = data;
                        this.isLoadingSource = false;
                    })
                }
                else {
                    this.isLoadingSource = false;
                }
            })
        }
    }

    setShowSource(val:boolean) {
        this.showSource = val;
    }
}
